import { ContentSearchDataOfContentSearchHit, ArticleSearchClient } from "../Generated/ParticaAPI";

export interface IArticleSearchService {
	SearchAccountArticles(accountId: number, data: ContentSearchDataOfContentSearchHit): Promise<ContentSearchDataOfContentSearchHit>;
	SearchPublicationArticles(accountId: number, data: ContentSearchDataOfContentSearchHit): Promise<ContentSearchDataOfContentSearchHit>;
	SearchGlobal(data: ContentSearchDataOfContentSearchHit): Promise<ContentSearchDataOfContentSearchHit>;
}

export class ArticleSearchService implements IArticleSearchService {
	private svc: ArticleSearchClient = new ArticleSearchClient();
	public async SearchAccountArticles(accountId: number, data: ContentSearchDataOfContentSearchHit):
		Promise<ContentSearchDataOfContentSearchHit> {
		if (data.query === "") {
			data.query = "*";
		}
		return await this.svc.accountArticleSearch(accountId, data);
	}
	public async SearchPublicationArticles(publicationId: number, data: ContentSearchDataOfContentSearchHit):
		Promise<ContentSearchDataOfContentSearchHit> {
		if (data.query === "") {
			data.query = "*";
		}
		return await this.svc.publicationArticleSearch(publicationId, data);
	}
	public async SearchGlobal(data: ContentSearchDataOfContentSearchHit): Promise<ContentSearchDataOfContentSearchHit> {
		if (data.query === "") {
			data.query = "*";
		}
		return await this.svc.globalSearch(data);
	}
}
